module.exports = __webpack_public_path__ + "img/comment.43833599.svg";